import styled, { css } from 'styled-components'

import { MEDIA_QUERIES } from "@constants"

import AnchorLink from '@components/AnchorLink/AnchorLink'

import ZapierLogo from "@static/images/integrations/logos/zapier-badge.png"

export const IntegrationsAppDirectoryGridDIV = styled.div.attrs({ className: "grid" })`
  margin-bottom: 40px;
`

export const IntegrationsAppDirectoryWrapperDIV = styled.div`
  h4 {
    text-align: center;
    margin-bottom: 50px;
  }
`

export const IntegrationsAppDirectorySearchDIV = styled.div`
  margin: 0 auto var(--spacing--M);
  width: max(616px, calc((var(--container-width) / 12 * 6) - (var(--spacing--M) * 6 / 12)));
`

export const IntegrationsAppDirectorySortDIV = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 30px;
  
  input {
    align-content: center;
  }

  strong,
  label {
    margin: 0 25px 20px;
    line-height: 24px;
  }

  strong {
    flex: 0 0 100%;
    text-align: center;

    ${MEDIA_QUERIES.S} {
      flex: 0 0 auto;
      line-height: 29px;
    }
  }

  label {
    transition: color 0.2s;
    align-items: center;
    display: flex;

    &:hover {
      color: var(--color--cobalt-600);
    }
  }

  label,
  input[type="radio"] {
    cursor: pointer;
  }

  input[type="radio"] {
    position: relative;
    top: -1px;
    margin-right: 8px;
  }
`

export const IntegrationsAppDirectoryCardLINK = styled(AnchorLink)`
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-radius: 6px;
  padding: var(--spacing--XS) var(--spacing--XS) var(--spacing--S);
  transition: all 0.3s;

  &:hover {
    box-shadow: var(--elevation--S);
  }

  .gatsby-image-wrapper {
    height: 60px !important;
    width: 60px !important;
    margin: var(--spacing--S) var(--spacing--S) var(--spacing--XS);
    display: block;

    ${MEDIA_QUERIES.M} { 
      height: 80px !important;
      width: 80px !important;
    }
  }

  h5 {
    font-size: var(--font-size--h6);
    text-align: center;
    margin: 0;
  }

  .Badge {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    font-size: 9px;

    ${MEDIA_QUERIES.M} {
      top: 30px;
    }
  }
`

const BadgeCSS = css`
  position: absolute;
  top: calc(50% + 10px);
  left: calc(50% + 50px);
  z-index: 1;
  transform: translate(-50%, -50%);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: center center / 68% auto black no-repeat;

  ${MEDIA_QUERIES.M} {
    top: calc(50% + 20px);
    left: calc(50% + 60px);
    width: 30px;
    height: 30px;
  }
`


export const ZapierBadgeDIV = styled.div`
  ${BadgeCSS}
  background-color: #ff5b10;
  background-image: url(${ZapierLogo});
`
